import { addDays } from '@if/core/date'
import { EIFinanceTeam, ELoanPurpose } from '@if/core/types'
import { formatUtcIsoDateTime } from '@if/core/utils'
import { CREDIT_DASHBOARD_FILTER_ALL, CreditDashboardFilters } from '../../data/types/CreditDashboardEntry'

export type CreditDashboardApiParams = Record<string, string | number | string[] | number[]>

export const buildApiParams = (values: CreditDashboardFilters): CreditDashboardApiParams => {
  const dates = values.dateRange && values.dateRange !== CREDIT_DASHBOARD_FILTER_ALL ? values.dateRange.split('@') : ['', '']
  const endDate = dates[1] || formatUtcIsoDateTime(addDays(new Date(), 1))

  const queryParams: CreditDashboardApiParams = {
    limit: values.limit,
    offset: values.offset,
    endDate,
    financingCompanyId: values.financingCompanyId,
  }

  if (values.creditApplicationStatus && values.creditApplicationStatus !== CREDIT_DASHBOARD_FILTER_ALL) {
    queryParams.creditApplicationStatus = values.creditApplicationStatus
  }

  if (values.financingProgramIds.length) queryParams.financingProgramIds = values.financingProgramIds
  if (values.territoryIds.length) queryParams.territoryIds = values.territoryIds
  if (values.loanPurposeIds.length) queryParams.loanPurposeIds = values.loanPurposeIds
  if (values.originSystemIds.length) queryParams.originSystemIds = values.originSystemIds
  if (values.plan.length) queryParams.plan = values.plan
  if (values.progressionStatus.length) queryParams.progressionStatus = values.progressionStatus
  if (values.merchantId) queryParams.merchantId = values.merchantId
  if (values.minAmountRequested) queryParams.minAmountRequested = values.minAmountRequested
  if (values.tag) queryParams.tag = values.tag
  if (dates[0]) queryParams.startDate = dates[0]
  if (values.searchTerm) queryParams.searchTerm = values.searchTerm

  if (values.team && values.team !== CREDIT_DASHBOARD_FILTER_ALL) {
    switch (values.team as EIFinanceTeam) {
      case EIFinanceTeam.IFinance:
        queryParams.loanPurposeIds = [ELoanPurpose.GoodsAndServices, ELoanPurpose.Veterinary]
        break
      case EIFinanceTeam.Medicard:
        queryParams.loanPurposeIds = [ELoanPurpose.Dentistry, ELoanPurpose.Medical, ELoanPurpose.Aesthetics]
        break
    }
  }

  return queryParams
}
